import React from 'react';
import PropTypes from 'prop-types';

export default class Module extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        instance: PropTypes.number,
        config: PropTypes.object,
    };

    static defaultProps = {
        instance: 0,
        config: {},
    };
}
